import { Button, Form, Switch } from "antd";
import { useEffect, useState } from "react";
import { notification } from "antd";
import { useCurrentUser, useUserMutation } from "../../api/Users";
import Loading from "../../components/Loading";
import { ContentTitle } from "../../layout/ContentLayout";

const { useForm } = Form;

const UserNotifications = ({ user }) => {
  const [form] = useForm();
  const [dirty, setDirty] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const userMutation = useUserMutation(user?.UserId);
  const submit = () => {
    setSubmitting(true);
    let values = form.getFieldsValue(null, (meta) => meta.touched);
    userMutation
      .mutateAsync(values)
      .then((r) => {
        notification.open({
          message: "Success",
          description: "Your notification preferences have been updated",
        });
        setDirty(false);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return !user ? (
    <Loading />
  ) : (
    <>
      <ContentTitle>Notifications</ContentTitle>
      <Form
        layout="vertical"
        initialValues={user}
        form={form}
        onFieldsChange={() => setDirty(true)}
        onFinish={submit}
      >
        <Form.Item
          name="EmailNotifications"
          label="Email"
          extra="Recieve email notifications for all activity"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item
          name="TextNotifications"
          label="Text"
          extra="Recieve text message notifications"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" disabled={!dirty || submitting}>
            {submitting ? "Updating" : "Update"}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default UserNotifications;
